import { CompanySettings } from '@domain/account/models/Company';

export type CatalogSubstep = 'leadTime' | 'buffer' | 'orderQuantity';

export const SUBSTEP_ORDER: CatalogSubstep[] = ['leadTime', 'buffer', 'orderQuantity'];
export const ACTIVE_JOBS_POLL_MS = 5000;

export const fieldSx = {
  width: 138,
  '& .MuiOutlinedInput-root': {
    borderRadius: '6px',
    bgcolor: '#FAFDFF',
    height: 40,
  },
} as const;

export const weeksToDays = (weeks: string) => Math.round((Number(weeks) || 0) * 7);

export const daysToWeeks = (days?: number) =>
  days != null ? String(Math.round((days / 7) * 10) / 10) : undefined;

export const formatDays = (days: number) => `${days} ${days === 1 ? 'day' : 'days'}`;

export const isLeadTimeComplete = (settings?: CompanySettings) =>
  settings?.defaultProductionDuration != null && settings?.defaultProcessingDuration != null;

export const isBufferComplete = (settings?: CompanySettings) =>
  settings?.defaultMinimumDaysOfStockInReserve != null;

export const isOrderQuantityComplete = (settings?: CompanySettings) =>
  settings?.defaultMinimumOrderAmountDays != null;

export const isSubstepComplete = (id: CatalogSubstep, settings?: CompanySettings) => {
  if (id === 'leadTime') return isLeadTimeComplete(settings);
  if (id === 'buffer') return isBufferComplete(settings);
  return isOrderQuantityComplete(settings);
};

export const areDefaultsComplete = (settings?: CompanySettings) =>
  SUBSTEP_ORDER.every((step) => isSubstepComplete(step, settings));

export const nextIncompleteSubstep = (settings?: CompanySettings): CatalogSubstep | null =>
  SUBSTEP_ORDER.find((step) => !isSubstepComplete(step, settings)) ?? null;
